import { css } from "@emotion/react";
import React, { forwardRef } from "react";
import { useTheme } from "../theme";

export interface PaperProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Paperの角に丸みを持たせるかを指定します。
   *
   * @default false
   */
  square?: boolean;
  /**
   * Paperの影の濃さと重なりを整数で指定します。数値が高いほど上に重なり、影は濃くなります。
   *
   * @default 1
   */
  elevation?: number;
}

export const Paper = forwardRef<HTMLDivElement, PaperProps>(function Paper(
  { elevation = 1, square = false, ...props },
  ref,
) {
  const theme = useTheme();

  return (
    <div
      ref={ref}
      css={css`
        position: relative;
        box-sizing: border-box;
        color: ${theme.palette.text.primary};
        background-color: ${theme.palette.background.paper};
        border-radius: ${square ? "0px" : "5px"};
        box-shadow: ${theme.shadows[elevation]};
      `}
      {...props}
    />
  );
});
